<div class="chat-settings">
  <!-- cabeçalho da página, como as outras páginas do CRM -->
  <div class="d-flex align-items-center flex-wrap gap-3 mb-4">
    <div class="flex-grow-1">
      <h1 class="chat-settings__title mb-1">{{ strings.settingsTitle }}</h1>
      <p class="text-muted mb-0">{{ strings.autoRepliesText }}</p>
    </div>
    <a [routerLink]="chatLink" class="btn btn-soft-primary d-inline-flex align-items-center gap-2">
      <chat-icon name="back" [size]="16"></chat-icon>
      {{ strings.backToChat }}
    </a>
  </div>

  <div class="row g-4">
    <!-- Respostas automáticas (só com canUseAutoReplies) -->
    <div *ngIf="showAutoReplies" class="col-12 col-xl-8">
      <ng-container *ngIf="loadingAuto">
        <div class="card chat-settings__card" *ngFor="let i of [0, 1]">
          <div class="card-header d-flex align-items-center gap-3">
            <span class="chat-settings__sk chat-settings__sk--title"></span>
            <span class="chat-settings__sk chat-settings__sk--btn ms-auto"></span>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-12 col-md-6" *ngFor="let j of [0, 1, 2, 3]">
                <div class="chat-settings__rule chat-settings__rule--sk">
                  <span class="chat-settings__sk chat-settings__sk--line"></span>
                  <span class="chat-settings__sk chat-settings__sk--area"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!loadingAuto">
        <!-- Gerais: editáveis com canAssign; senão em leitura (só se existirem) -->
        <div *ngIf="canEditGeneral || hasGeneral" class="card chat-settings__card" [attr.aria-label]="strings.autoRepliesGeneral">
          <div class="card-header d-flex align-items-center gap-3">
            <span class="chat-settings__card-icon chat-settings__card-icon--primary"><chat-icon name="users" [size]="18"></chat-icon></span>
            <div class="flex-grow-1 min-w-0">
              <h2 class="chat-settings__h2 mb-0">{{ strings.autoRepliesTitle }} · {{ strings.autoRepliesGeneral }}</h2>
              <p *ngIf="!canEditGeneral" class="text-muted small mb-0">{{ strings.autoRepliesReadOnly }}</p>
            </div>
            <button *ngIf="canEditGeneral" type="button" class="btn btn-primary d-inline-flex align-items-center gap-2"
              [disabled]="savingAuto || !hasDirty(generalRows)" (click)="saveSection(generalRows)">
              <span *ngIf="savingAuto" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ savingAuto ? strings.saving : strings.save }}
            </button>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div *ngFor="let row of generalRows" class="col-12 col-md-6">
                <ng-container *ngTemplateOutlet="ruleCard; context: { row: row, editable: canEditGeneral, scope: 'general' }"></ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- Próprias: sempre editáveis -->
        <div class="card chat-settings__card mb-0" [attr.aria-label]="strings.autoRepliesMine">
          <div class="card-header d-flex align-items-center gap-3">
            <span class="chat-settings__card-icon chat-settings__card-icon--success"><chat-icon name="bolt" [size]="18"></chat-icon></span>
            <div class="flex-grow-1 min-w-0">
              <h2 class="chat-settings__h2 mb-0">{{ strings.autoRepliesTitle }} · {{ strings.autoRepliesMine }}</h2>
            </div>
            <button type="button" class="btn btn-primary d-inline-flex align-items-center gap-2"
              [disabled]="savingAuto || !hasDirty(mineRows)" (click)="saveSection(mineRows)">
              <span *ngIf="savingAuto" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ savingAuto ? strings.saving : strings.save }}
            </button>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div *ngFor="let row of mineRows" class="col-12 col-md-6">
                <ng-container *ngTemplateOutlet="ruleCard; context: { row: row, editable: true, scope: 'mine' }"></ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Respostas rápidas -->
    <div class="col-12" [class.col-xl-4]="showAutoReplies">
      <div class="card chat-settings__card mb-0">
        <div class="card-header d-flex align-items-center gap-3">
          <span class="chat-settings__card-icon chat-settings__card-icon--warning"><chat-icon name="note" [size]="18"></chat-icon></span>
          <div class="flex-grow-1 min-w-0">
            <h2 class="chat-settings__h2 mb-0">{{ strings.quickRepliesTitle }}</h2>
            <p class="text-muted small mb-0">{{ strings.quickRepliesText }}</p>
            <p class="text-muted small mb-0 chat-settings__vars">{{ strings.variablesHint }}</p>
          </div>
          <button type="button" class="btn btn-soft-primary btn-icon" [attr.aria-label]="strings.newQuickReply"
            [ngbTooltip]="strings.newQuickReply" container="body" (click)="openQuickModal(quickModal)">
            <chat-icon name="plus" [size]="18"></chat-icon>
          </button>
        </div>
        <div class="card-body p-0">
          <div *ngIf="loadingQuick" class="p-3" role="status" [attr.aria-label]="strings.loading">
            <div *ngFor="let i of [0, 1, 2]" class="chat-settings__sk chat-settings__sk--row"></div>
          </div>
          <div *ngIf="!loadingQuick && quickReplies.length === 0" class="chat-settings__empty">
            <span class="chat-settings__empty-icon"><chat-icon name="bolt" [size]="22"></chat-icon></span>
            <p class="text-muted mb-2">{{ strings.noQuickReplies }}</p>
            <button type="button" class="btn btn-sm btn-soft-primary" (click)="openQuickModal(quickModal)">{{ strings.newQuickReply }}</button>
          </div>
          <div *ngFor="let r of quickReplies; trackBy: trackByQuick" class="chat-settings__quick" [class.chat-settings__quick--off]="r.status === false">
            <div class="flex-grow-1 min-w-0">
              <div class="d-flex align-items-center flex-wrap gap-2">
                <span class="chat-settings__shortcut">{{ r.shortcut }}</span>
                <span *ngIf="r.general" class="badge badge-soft-primary">{{ strings.generalTag }}</span>
                <span *ngIf="r.status === false" class="badge badge-soft-dark">{{ strings.inactiveTag }}</span>
              </div>
              <div class="chat-settings__message">{{ r.message }}</div>
            </div>
            <div *ngIf="canEditQuick(r)" class="chat-settings__quick-actions d-flex gap-1 flex-shrink-0">
              <button type="button" class="btn btn-sm btn-soft-secondary btn-icon" [attr.aria-label]="strings.edit" [ngbTooltip]="strings.edit"
                container="body" (click)="openQuickModal(quickModal, r)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                  stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17z"/><path d="m13.5 6.5 3 3"/></svg>
              </button>
              <button type="button" class="btn btn-sm btn-soft-danger btn-icon" [attr.aria-label]="strings.delete" [ngbTooltip]="strings.delete"
                container="body" (click)="deleteQuick(r)">
                <chat-icon name="trash" [size]="15"></chat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Um cartão por gatilho: título, ajuda (tooltip), toggle e texto -->
<ng-template #ruleCard let-row="row" let-editable="editable" let-scope="scope">
  <div class="chat-settings__rule" [class.chat-settings__rule--off]="!row.status" [class.chat-settings__rule--dirty]="row.dirty">
    <div class="d-flex align-items-center gap-2 mb-2">
      <h4 class="chat-settings__rule-title mb-0 flex-grow-1 min-w-0 d-flex align-items-center gap-2">
        <span class="text-truncate">{{ strings.triggers[row.trigger] || row.trigger }}</span>
        <button type="button" class="chat-settings__help" [attr.aria-label]="strings.triggerHelp + ': ' + (strings.triggerHints[row.trigger] || '')"
          [ngbTooltip]="strings.triggerHints[row.trigger] || ''" container="body" placement="top">
          <chat-icon name="help" [size]="14"></chat-icon>
        </button>
      </h4>
      <span *ngIf="row.saving" class="badge badge-soft-secondary d-inline-flex align-items-center gap-1" role="status">
        <span class="spinner-border spinner-border-sm chat-settings__spinner" aria-hidden="true"></span>{{ strings.saving }}
      </span>
      <span *ngIf="!row.saving && row.saved" class="badge badge-soft-success d-inline-flex align-items-center gap-1" role="status">
        <chat-icon name="check" [size]="11"></chat-icon>{{ strings.saved }}
      </span>
      <div class="form-check form-switch form-switch-md form-switch-primary mb-0 ms-1" [ngbTooltip]="strings.activeLabel" container="body">
        <input type="checkbox" class="form-check-input" role="switch" [id]="'chat-rule-' + scope + '-' + row.trigger"
          [attr.aria-label]="strings.activeLabel" [(ngModel)]="row.status" (ngModelChange)="markDirty(row)" [disabled]="!editable || row.saving">
      </div>
    </div>
    <label class="chat-sr-only" [for]="'chat-rule-text-' + scope + '-' + row.trigger">{{ strings.messageLabel }}</label>
    <textarea rows="3" class="form-control chat-settings__textarea" maxlength="2000" [id]="'chat-rule-text-' + scope + '-' + row.trigger"
      [placeholder]="strings.messageLabel" [(ngModel)]="row.message" (ngModelChange)="markDirty(row)"
      [disabled]="!editable || row.saving" [readonly]="!editable"></textarea>
  </div>
</ng-template>

<!-- Criar / editar resposta rápida -->
<ng-template #quickModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ quickForm.id ? strings.editQuickReply : strings.newQuickReply }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label" for="chat-quick-shortcut">{{ strings.shortcutLabel }}</label>
      <input id="chat-quick-shortcut" type="text" class="form-control" autocomplete="off" maxlength="40" [(ngModel)]="quickForm.shortcut" name="shortcut">
      <div class="form-text">{{ strings.shortcutHint }}</div>
    </div>
    <div class="mb-3">
      <label class="form-label" for="chat-quick-message">{{ strings.messageLabel }}</label>
      <textarea id="chat-quick-message" rows="4" class="form-control" maxlength="2000" [(ngModel)]="quickForm.message" name="message"></textarea>
    </div>
    <div class="form-check form-switch form-switch-md form-switch-primary mb-2">
      <input id="chat-quick-status" type="checkbox" class="form-check-input" role="switch" [(ngModel)]="quickForm.status" name="status">
      <label class="form-check-label" for="chat-quick-status">{{ strings.activeLabel }}</label>
    </div>
    <div *ngIf="canEditGeneral && !quickForm.id" class="form-check form-switch form-switch-md form-switch-primary">
      <input id="chat-quick-general" type="checkbox" class="form-check-input" role="switch" [(ngModel)]="quickForm.general" name="general">
      <label class="form-check-label" for="chat-quick-general">{{ strings.generalLabel }}</label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.cancel }}</button>
    <button type="button" class="btn btn-primary d-inline-flex align-items-center gap-2" [disabled]="!quickFormValid || savingQuick" (click)="saveQuick()">
      <span *ngIf="savingQuick" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      {{ savingQuick ? strings.saving : (quickForm.id ? strings.save : strings.create) }}
    </button>
  </div>
</ng-template>
